// Utility to handle idle callbacks with fallback
export const requestIdleCallbackWithFallback = (callback: () => void, options?: { timeout?: number }) => {
  if (typeof window.requestIdleCallback === "function") {
    return window.requestIdleCallback(callback, options);
  }
  return window.setTimeout(callback, options?.timeout || 100);
};

export const cancelIdleCallbackWithFallback = (id: number) => {
  if (typeof window.cancelIdleCallback === "function") {
    window.cancelIdleCallback(id);
  } else {
    window.clearTimeout(id);
  }
};
